import en from './en'
import th from './th'

export default { en, th }



// WEBPACK FOOTER //
// ./src/i18n/index.js